// 🚨 Will fix after merge
/* eslint-disable @typescript-eslint/no-explicit-any */
export var isMultipleExceptions = function (exceptions) {
    var workorderExceptions = [];
    exceptions === null || exceptions === void 0 ? void 0 : exceptions.forEach(function (exception) {
        var _a, _b, _c, _d;
        if ((exception === null || exception === void 0 ? void 0 : exception.shippingAndHandling) &&
            ((_a = exception === null || exception === void 0 ? void 0 : exception.shippingAndHandling) === null || _a === void 0 ? void 0 : _a.applianceDeliveries)) {
            var applianceDeliveries = (_b = exception === null || exception === void 0 ? void 0 : exception.shippingAndHandling) === null || _b === void 0 ? void 0 : _b.applianceDeliveries[0];
            var workOrderException = applianceDeliveries === null || applianceDeliveries === void 0 ? void 0 : applianceDeliveries.workOrderException;
            if (workOrderException &&
                !workorderExceptions.includes(workOrderException)) {
                workorderExceptions.push(workOrderException);
            }
        }
        if ((exception === null || exception === void 0 ? void 0 : exception.bodfsDeliveryAndHandling) &&
            ((_c = exception === null || exception === void 0 ? void 0 : exception.bodfsDeliveryAndHandling) === null || _c === void 0 ? void 0 : _c.bodfsDeliveries)) {
            var bodfsDelivery = (_d = exception === null || exception === void 0 ? void 0 : exception.bodfsDeliveryAndHandling) === null || _d === void 0 ? void 0 : _d.bodfsDeliveries[0];
            var workOrderException = bodfsDelivery === null || bodfsDelivery === void 0 ? void 0 : bodfsDelivery.workOrderException;
            if (workOrderException &&
                !workorderExceptions.includes(workOrderException)) {
                workorderExceptions.push(workOrderException);
            }
        }
    });
    if (workorderExceptions.length > 1) {
        return 'Multiple';
    }
    return workorderExceptions[0];
};
